// extracted by mini-css-extract-plugin
module.exports = {"legendRow":"Esg_legendRow__1We83","progressRow":"Esg_progressRow__afsdk","separator":"Esg_separator__3bT7E"};